exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[dir] ._3gytIGZu8dmJ7coKbgACWg{margin-bottom:10px}", ""]);

// exports
exports.locals = {
	"appearanceWrapper": "_3gytIGZu8dmJ7coKbgACWg"
};